import axios from "axios";
import {refactorEventsGroupedByDateV1} from "@/services/eventsOddsHandlerV3";

const COOLDOWN_MS = 120000; // 2 minutes cooldown

const state = {
    events: [],
    sports: [],
    paging: {
        total: 0,
        page: 1,
        pages: 1
    },
    loading: true,
    lastFetchMap: {} // Tracks timestamps for cooldowns: { "sportId_page": timestamp }
};

const getters = {
    getFormattedEvents: (state) => state.events,
    getSports: (state) => state.sports,
    getPaging: (state) => state.paging,
    isLoading: (state) => state.loading
};

const mutations = {
    SET_LOADING(state, status) {
        state.loading = status;
    },

    SET_DATA(state, {events, paging, sports}) {
        state.events = events;

        if (paging) state.paging = paging;
        if (sports) state.sports = sports;
    },

    SET_LAST_FETCH(state, {key, time}) {
        state.lastFetchMap = {...state.lastFetchMap, [key]: time};
    },

    RESET_DATA(state) {
        state.events = [];
        state.paging = {total: 0, page: 1, pages: 1};
    }
};

const actions = {
    async fetchNextEvents(context, payload) {
        if (context.rootGetters['ui/getAppSection'] === 'live') return;
        const p = payload || {};

        // Cooldown Logic Variables
        const force = p.force || false;
        const sportId = p.sportId || null;
        const page = p.page || 1;
        const cacheKey = `${sportId}_${page}`;
        const now = Date.now();

        // Check cooldown
        if (!force && context.state.lastFetchMap[cacheKey]) {
            if (now - context.state.lastFetchMap[cacheKey] < COOLDOWN_MS) {
                return;
            }
        }

        context.commit('SET_LOADING', true);

        const requestPayload = {
            platformId: context.rootGetters['settings/getPlatformId'],
            sportId: sportId,
            page: page,
            limit: p.limit || context.rootGetters['settings/getNextEventsMaxEventsForPage'] || 10,
            language_user: p.language_user,
            mobilePlatform: p.mobilePlatform || false
        };

        const apiUrl = context.rootGetters['settings/getUrlApi'];
        const token = context.rootGetters['settings/getToken'];
        const url = `${apiUrl}/v3/events/prematch/upcoming`;

        const headers = {
            Authorization: `Bearer ${token}`
        };

        try {
            const response = await axios.post(url, requestPayload, {headers});
            const data = response.data;

            context.commit('SET_LAST_FETCH', {key: cacheKey, time: Date.now()});

            if (data && data.result && data.result.events && data.result.events.length > 0) {

                const formattedEvents = refactorEventsGroupedByDateV1(data.result);

                context.commit('SET_DATA', {
                    events: formattedEvents,
                    paging: data.result.paging,
                    sports: data.result.sports
                });

                if (data.result.headerSign) {
                    // context.dispatch(
                    //     'marketview/updateSpreadsListAndSpreadSelectedV3',
                    //     {
                    //         type: 'nextEvents',
                    //         headerSign: data.result.headerSign,
                    //         sport: requestPayload.sportId,
                    //         events: data.result.events
                    //     },
                    //     {root: true}
                    // );
                }

            } else {
                context.commit('RESET_DATA');
            }

        } catch (error) {
            console.error("Error in fetchNextEvents:", error);
            context.commit('RESET_DATA');
            context.commit('SET_LAST_FETCH', { key: cacheKey, time: Date.now() });
        } finally {
            context.commit('SET_LOADING', false);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};